// extracted by mini-css-extract-plugin
export default {"item":"style-module--item--46zXS","space":"style-module--space--nJQRk"};